import { render, staticRenderFns } from "./AuthMask.vue?vue&type=template&id=36385daf&"
import script from "./AuthMask.vue?vue&type=script&lang=js&"
export * from "./AuthMask.vue?vue&type=script&lang=js&"
import style0 from "./AuthMask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports